import { PermissionType } from './permission-type';

export class Permission{

    //List of temporary permissions.  Real list to come soon
    public static readonly CLUB_GOAL:number = 1;
    public static readonly CLUB_GROUP_VIEW:number = 2;
    public static readonly DISTRICT_VIEW:number = 3;
    public static readonly COORDINATOR_VIEW:number = 4;
    public static readonly GLOBAL_VIEW:number = 5;
    public static readonly RATE_CLUBS:number = 6;
    public static readonly RESOURCES:number = 7;
    public static readonly YOUR_CLUB_REPORTS:number = 8;
    public static readonly SERVICE_REPORTS:number = 9;
    public static readonly FOUNDATION_GIVING_REPORTS:number = 10;

    public PermissionId:number;
    public Name:string;
    public Description:string;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/entities/permission.ts